import React from "react";
import PropTypes from "prop-types";

const Dialog = ({
  isOpen,
  onClose,
  title,
  children,
  width = "max-w-2xl",
  closeOnOverlayClick = true,
  className = "", // 添加className参数
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      // 提高基础z-index到1000，并支持自定义className
      className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000] ${className}`}
      onClick={handleOverlayClick}
    >
      <div
        className={`bg-white rounded-lg w-full ${width} max-h-[90vh] flex flex-col`}
      >
        {/* 保持原有内容不变 */}
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors duration-200"
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <div className="overflow-y-auto p-4 flex-1">{children}</div>
      </div>
    </div>
  );
};

Dialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  width: PropTypes.string,
  closeOnOverlayClick: PropTypes.bool,
};

export default Dialog;
